import { gql } from "@apollo/client";

import { mylensesOrganizationsFragment, organizationsFragment } from "../../../shared/api/fragments";
import { organizationsAvailableForLensSpaceCreationFragment, preSubmissionInfoFragment } from "../fragments";

export const getAllPreSubmissionInfoWithOrgResources = gql`
    query getAllPreSubmissionInfoWithOrgResources($submissionId: ID!) {
        getMyLensesOrganizations {
            ...Organizations
        }
        getPreSubmissionInfo(input: { submissionId: $submissionId }) {
            ...PreSubmissionInfo
        }
    }
    ${organizationsFragment}
    ${preSubmissionInfoFragment}
`;

export const getAllPresubmissionInfoWithOrgsAvailableForLensSpaceCreation = gql`
    query getAllPresubmissionInfoWithOrgsAvailableForLensSpaceCreation($submissionId: ID!) {
        getMyLensesOrganizationsAvailableForLensSpaceCreation {
            ...OrganizationsAvailableForLensSpaceCreation
        }
        getPreSubmissionInfo(input: { submissionId: $submissionId }) {
            ...PreSubmissionInfo
        }
    }
    ${organizationsAvailableForLensSpaceCreationFragment}
    ${preSubmissionInfoFragment}
`;

export const getAllPresubmissionInfoWithOrgResourcesAndOrgsAvailableForLensSpaceCreation = gql`
    query getAllPresubmissionInfoWithOrgResourcesAndOrgsAvailableForLensSpaceCreation($submissionId: ID!) {
        getMyLensesOrganizations {
            ...Organizations
        }
        getMyLensesOrganizationsAvailableForLensSpaceCreation {
            ...OrganizationsAvailableForLensSpaceCreation
        }
        getPreSubmissionInfo(input: { submissionId: $submissionId }) {
            ...PreSubmissionInfo
        }
    }
    ${organizationsFragment}
    ${organizationsAvailableForLensSpaceCreationFragment}
    ${preSubmissionInfoFragment}
`;

export const getAllPreSubmissionInfoWithOrgsForLensSpaceCreationV2 = gql`
    query getAllPreSubmissionInfoWithOrgsForLensSpaceCreationV2($submissionId: ID!, $limit: Int!, $cursor: String!) {
        myLensesOrganizationsForLensSpaceCreation(input: { limit: $limit, cursor: $cursor }) {
            ...MyLensesOrganizations
        }
        getPreSubmissionInfo(input: { submissionId: $submissionId }) {
            ...PreSubmissionInfo
        }
    }
    ${mylensesOrganizationsFragment}
    ${preSubmissionInfoFragment}
`;
